import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const AvantageIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M2.66699 2.08331H13.333C14.3916 2.08331 15.25 2.94176 15.25 4.00031V5.68488C15.25 5.89637 15.14 6.09252 14.96 6.20343C13.6222 7.02714 13.6223 8.97244 14.96 9.7962C15.14 9.90709 15.25 10.1033 15.25 10.3148V12.0003C15.2498 13.0587 14.3914 13.9163 13.333 13.9163H2.66699C1.60855 13.9163 0.750176 13.0587 0.75 12.0003V10.3148C0.750031 10.1033 0.859957 9.90709 1.04004 9.7962C2.37772 8.97244 2.37779 7.02713 1.04004 6.20343C0.859958 6.09252 0.75 5.89637 0.75 5.68488V4.00031C0.75 2.94176 1.60845 2.08331 2.66699 2.08331Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8552 11.5555C10.8552 11.1413 10.5194 10.8055 10.1052 10.8055C9.69101 10.8055 9.35522 11.1413 9.35522 11.5555H10.1052H10.8552ZM10.1052 14.6667H10.8552V11.5555H10.1052H9.35522V14.6667H10.1052Z"
      fill="currentColor"
    />
    <path
      d="M10.1052 8.88885V6.66663"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.35522 3.99998C9.35522 4.41419 9.69101 4.74998 10.1052 4.74998C10.5194 4.74998 10.8552 4.41419 10.8552 3.99998H10.1052H9.35522ZM10.1052 1.33331H9.35522V3.99998H10.1052H10.8552V1.33331H10.1052Z"
      fill="currentColor"
    />
  </svg>
));
